import React, { useState, useEffect } from 'react';
import { WIDGET_LINK } from '../../config';

const TestWidget = () => {
  const [widgetButton, setWidgetButton] = useState('');

  useEffect(() => {
    const script = document.createElement('script');
    script.src = WIDGET_LINK;
    script.async = true;

    document.body.appendChild(script);
  }, []);

  const handleChange = e => {
    setWidgetButton(e.target.value);
  };

  return (
    <div>
      <textarea
        style={{ width: '400px', height: '100px' }}
        value={widgetButton}
        onChange={handleChange}
        placeholder="Please insert a widget button"
      />
      <div dangerouslySetInnerHTML={{ __html: widgetButton }} />
    </div>
  );
};

export default TestWidget;
